import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const ORDERS_TABS = [
  'info',
  'order_items',
  'memberships',
  'skipass_items',
  'provider_items',
  'pickup_items',
  'dealer_items',
  'tasks',
  'tasks_cloud',
  'audit',
  'history',
  'payment_errors',
  'item_transfers',
  'admin_notes',
  'emails',
] as const;

export type OrdersTabs = (typeof ORDERS_TABS)[number];

export const OrdersPath: MainPath = '/orders/:id?/:section?';
export const CassaPath: MainPath = '/cassaskipass';
export const CartsPath: MainPath = '/cart/:id?/:section?';

export const CART_TABS = ['info', 'items', 'history'] as const;

export type CartTabs = (typeof CART_TABS)[number];

export const OrdersRoute: MainNavRoute = {
  path: '/orders',
  label: 'routes.orders',
  icon: 'invoice',
  type: 1,
  permissions: [PERMISSIONS.ORDERS__LIST],
  children: [
    {
      path: ':id',
      permissions: [PERMISSIONS.ORDERS__DETAILS],
      children: makeChildren<OrdersTabs>({
        info: { path: 'info' },
        order_items: { path: 'order_items' },
        memberships: { path: 'memberships', type: 0 },
        skipass_items: { path: 'skipass_items' },
        provider_items: { path: 'provider_items' },
        dealer_items: { path: 'dealer_items', permissions: [PERMISSIONS.ORDERS__DEALERS] },
        pickup_items: { path: 'pickup_items', permissions: [PERMISSIONS.ORDERS__PICKUP] },
        tasks: { path: 'tasks', permissions: [PERMISSIONS.TASKS__LIST] },
        tasks_cloud: { path: 'tasks_cloud', permissions: [PERMISSIONS.ORDERS__MAILER_ERRORS] },
        audit: { path: 'audit', permissions: [PERMISSIONS.ORDERS__AUDIT] },
        history: { path: 'history', permissions: [PERMISSIONS.ORDERS__HISTORY] },
        payment_errors: {
          path: 'payment_errors',
          permissions: [PERMISSIONS.ORDERS__PAYMENT_ERRORS],
        },
        item_transfers: {
          path: 'item_transfers',
          permissions: [PERMISSIONS.ORDERS__ITEM_TRANSFERS],
        },
        admin_notes: { path: 'admin_notes', type: 0 },
        emails: { path: 'emails', type: 0 },
      }),
    },
  ],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-25341/bee0cb68a32bdbf',
};

export const CassaRoute: MainNavRoute = {
  path: '/cassaskipass',
  label: 'routes.cassa_skipass',
  icon: 'list',
  type: 1,
  permissions: [PERMISSIONS.CASSA_SKIPASS__LIST],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-23721/c02bf4aa472af38',
};

export const CartsRoute: MainNavRoute = {
  path: '/cart',
  label: 'routes.cart',
  icon: 'cart',
  type: 1,
  permissions: [PERMISSIONS.CART__LIST],
  children: [
    {
      path: ':id',
      permissions: [PERMISSIONS.CART__DETAILS],
      children: makeChildren<CartTabs>({
        info: { path: 'info' },
        items: { path: 'items' },
        history: { path: 'history' },
      }),
    },
  ],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-23741/38ab568f26b4de7',
};
